import { ChevronDown } from 'lucide-react'
import styles from './SortDirectionIcon.module.css'

type SortDirectionIconProps = {
  direction?: 'asc' | 'desc'
  size?: number
}

export const SortDirectionIcon = ({ direction = 'desc', size = 13 }: SortDirectionIconProps) => (
  <ChevronDown
    aria-hidden="true"
    className={[styles.icon, direction === 'asc' ? styles.asc : ''].filter(Boolean).join(' ')}
    size={size}
  />
)
